

import { useEffect, useState } from 'react';

export default function ParticipantStatsOverlay({ participant }) {
  const [stats, setStats] = useState(null);
  const [isLocal, setIsLocal] = useState(false);

  useEffect(() => {
    if (!participant) return;
    
    // Find the first video track publication from the participant
    const videoPublication = Array.from(participant.videoTracks.values())[0];
    if (!videoPublication || !videoPublication.track) return;
    
    const videoTrack = videoPublication.track;
    
    let interval = setInterval(async () => {
      try {
        // Get the sender for the track (if it's a local participant)
        // or the receiver (if it's a remote participant)
        const sender = videoTrack.sender || videoTrack.receiver;
        if (!sender) return;
        
        // Get WebRTC stats using the standard getStats() method
        const statsReport = await sender.getStats();
        
        // Process the stats report
        let processedStats = {
          bitrate: 0,
          width: 0,
          height: 0,
          framerate: 0,
          packetsLost: 0,
          jitter: 0
        };
        
        // Track if we're seeing local or remote stats
        let foundLocalStats = false;
        
        statsReport.forEach(report => {
          // For local participants (outbound) or remote participants (inbound)
          if (report.type === 'outbound-rtp' && report.kind === 'video') {
            // Local participant sending stats
            processedStats.bitrate = report.bytesSent ? report.bytesSent * 8 : 0;
            processedStats.packetsLost = report.packetsLost || 0;
            processedStats.framerate = report.framesPerSecond || 0;
            foundLocalStats = true;
          } else if (report.type === 'inbound-rtp' && report.kind === 'video') {
            // Remote participant receiving stats
            processedStats.bitrate = report.bytesReceived ? report.bytesReceived * 8 : 0;
            processedStats.packetsLost = report.packetsLost || 0;
            processedStats.framerate = report.framesPerSecond || 0;
            processedStats.jitter = report.jitter ? Math.round(report.jitter * 1000) : 0; // Convert to ms
          }
          
          // Look for track stats for resolution
          if (report.type === 'track' && report.kind === 'video') {
            processedStats.width = report.frameWidth || 0;
            processedStats.height = report.frameHeight || 0;
          }
        });
        
        setStats(processedStats);
        setIsLocal(foundLocalStats);
      } catch (error) {
        console.error('Error getting track stats:', error);
      }
    }, 2000);
    
    return () => clearInterval(interval);
  }, [participant]);

  if (!stats) return null;

  return (
    <div style={{
      position: 'absolute',
      top: 4,
      left: 4,
      backgroundColor: isLocal ? 'rgba(0,100,0,0.7)' : 'rgba(0,0,100,0.7)',
      color: 'white',
      padding: '4px 6px',
      fontSize: '12px',
      borderRadius: '4px',
      zIndex: 1000
    }}>
      <div><strong>{isLocal ? 'Local Stats' : 'Remote Stats'}</strong></div>
      <div>Bitrate: {Math.round(stats.bitrate / 1000)} kbps</div>
      <div>Resolution: {stats.width}x{stats.height}</div>
      <div>FPS: {stats.framerate}</div>
      <div>Packets Lost: {stats.packetsLost}</div>
      {!isLocal && <div>Jitter: {stats.jitter} ms</div>}
    </div>
  );
}